import { IWhiteboardLinkState } from "../links";
import { IWhiteboardShapeState } from "../shapes";

export interface IWhiteboardStateChange {
  op: "add" | "replace" | "remove";
  path: string;
  bsonId?: string;
  value: IWhiteboardLinkState | IWhiteboardShapeState;
}

export interface IWhiteboardStateChangeNotifier {
  stateChange(changes: IWhiteboardStateChange[]): void;
}

class NullWhiteboardStateChangeNotifier implements IWhiteboardStateChangeNotifier {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  stateChange(changes: IWhiteboardStateChange[]): void {
    // do nothing
  }
}

export const nullWhiteboardStateChangeNotifier = new NullWhiteboardStateChangeNotifier();
